module.exports = __webpack_public_path__ + "static/099e3896-ba41-4a36-b5f1-1abcd3f47199-350.7f7d5e74.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/fluted-vase-sky-blue/099e3896-ba41-4a36-b5f1-1abcd3f47199-350.jpg
// module id = 964
// module chunks = 168707334958949